import type { FaireProductEntity } from "../../entity_types/product";

export const p_q2jfmskvgq: FaireProductEntity = {
  token: "p_q2jfmskvgq",
  type: "product",
  name: "Green Flowers",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/727afa5fa62734f2da97e0e4b7ade2c740eddfc51eea97aa1594b768935aa765.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc4f53484ecf026a85ef5be316ed3abc067751591ea0acaa56a5f589c9d68af5.jpeg",
    "https://cdn.faire.com/fastly/c27d3fcddb32807b46f864c3d11b96acd8a959f832b6467cec20f313b5e81f02.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:53.420Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
